import { AddIcon, Button, Grid, GridRow } from '@bp/ui-components';
import { FieldArray, useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useCreateSelectOptions } from '../../../../hooks/useCreateSelectOptions';
import { useLoadBasicData } from '../../../../hooks/useLoadBasicData';
import { LessonFormType } from '../../types';
import { LessonRoomSupplyFormItem } from './LessonRoomSupplyFormItem';

type LessonRoomSupplyFormProps = { disabled: boolean };

export const LessonRoomSupplyForm = observer(({ disabled }: LessonRoomSupplyFormProps) => {
  const { t } = useTranslation();

  const { values, setFieldTouched } = useFormikContext<LessonFormType>();

  const { roomsData } = useLoadBasicData({ pause: false });

  const usedRoomUuids: string[] = values.roomSupply?.map((rs) => rs.uuid ?? '') ?? [];
  const options = useCreateSelectOptions(roomsData?.rooms, 'uuid', 'name');

  return (
    <FieldArray name={'roomSupply'}>
      {(arrayHelpers) => {
        return (
          <Grid useFormGap>
            {values.roomSupply?.map((room, index) => {
              const current = options.find((option) => {
                return option.value === room.uuid;
              }) ?? { value: '', label: '' };

              return (
                <LessonRoomSupplyFormItem
                  key={room.uuid ?? index}
                  index={index}
                  current={current}
                  options={options}
                  usedRoomUuids={usedRoomUuids}
                  disabled={disabled}
                  onDelete={() => arrayHelpers.remove(index)}
                />
              );
            })}

            <GridRow spacingBottom='none' spacingTop='none'>
              <Button
                hierarchy='tertiary'
                disabled={!values.subject || disabled}
                icon={<AddIcon />}
                onClick={async () => {
                  if (values.roomSupply && values.roomSupply.length > 0) {
                    for (const index in values.roomSupply) {
                      await setFieldTouched(`roomSupply.${index}`);
                    }
                  }
                  arrayHelpers.push({});
                }}
              >
                {t('rooms.add')}
              </Button>
            </GridRow>
          </Grid>
        );
      }}
    </FieldArray>
  );
});
